import React, { useState } from 'react'
import "./enterCode.css"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Popup from '../popupContent/popup'
import sendCode from '../../API/sendCode'

const cases = ["win", "lose", "error"]

const inputFields = [{ "name": "email", "placeHolder": "e-mail", "value": "", "err": "", "isSelected": false, "isBlured": false },
{ "name": "phone", "placeHolder": "Broj telefona", "value": "", "err": "", "isSelected": false, "isBlured": false },
{ "name": "email", "placeHolder": "e-mail", "value": "", "err": "", "isSelected": false, "isBlured": false }]

const SigninSchema = yup.object().shape({
  email: yup.string().matches(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i, "E-mail адреса мора бити у исправном формату")
    .required("Ово поље је обавезно"),
  phone: yup.string().matches(/^06\d{7,8}$/, "Број телефона мора почети са 06X и имати укупно 9 или 10 цифара")
    .min(9, "Ово поље мора садржати 9 или 10 цифара")
    .max(10, "Ово поље мора садржати 9 или 10 цифара")
    .required("Ово поље је обавезно"),
  code: yup.string().matches(/^[a-zA-Z0-9]+$/, "Ово поље мора садржати само алфанумеричке карактере")
    .min(8, "Ово поље мора садржати тачно 8 карактера")
    .max(8, "Ово поље мора садржати тачно 8 карактера")
    .required("Ово поље је обавезно"),
});

const EnterCode = () => {

  const [serverResponse, setServerResponse] = useState(false)
  const [consentApproved, setConsentApproved] = useState(false)
  const [acceptRules, setAcceptRules] = useState(false)
  const [prizeCode, setPrizeCode] = useState(false)
  const [checkboxErr, setCheckboxErr] = useState(false)


  const handleConsentApproved = () => setConsentApproved(!consentApproved)
  const handleAcceptRules = () => setAcceptRules(!acceptRules)

  const onSubmit = async (data) => {
    data["consentApproved"] = consentApproved
    data["code"] = data["code"].toUpperCase()

    if (acceptRules) {
      let response = await sendCode(data)
      if (response?.data?.success) {
        setServerResponse(response?.data?.success.data.response.code)
        console.log(response?.data?.success.data.response)
        // If prize iz won here we will see prize code
        if (response?.data?.success.data.response.code === "4") {
          setPrizeCode(response?.data?.success.data.response.prize_id)
        }

        setTimeout(() => {
          setServerResponse(false)
          setPrizeCode(false)
        }, 7000);
      }

      else {
        alert("Error")
      }
    }
    else {
      setCheckboxErr(true)
      setTimeout(() => {
        setCheckboxErr(false)
      }, 7000);
    }
  }


  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(SigninSchema)
  })

  return (
    <div className="content codePage">
      <div className="enterCode">Унеси код:</div>

      <input type="text" name="code" {...register('code')} className="codeName" placeholder='_ _ _ _ _ _ _ _' maxlength="8" />
      {errors['code'] && <span className='err'>{errors['code'].message}</span>}

      <div className="lineBreak"></div>

      <input type="text" {...register('phone')} className="phone" name="phone" placeholder='Број телефона...' maxlength="10" />
      {errors['phone'] && <span className='err'>{errors['phone'].message}</span>}

      <input type="text" {...register('email')} className="phone" name="email" placeholder='Електронска адреса...' />
      {errors['email'] && <span className='err'>{errors['email'].message}</span>}

      <div className="acceptHolder">
        <input type="checkbox" onChange={handleAcceptRules} />
        <div>Прихватам правила наградне игре
          {checkboxErr && !acceptRules && <span className="checkboxErr"> *Ово поље је обавезно.</span>}
        </div>
      </div>

      <div className="acceptHolder">
        <input type="checkbox" onChange={handleConsentApproved} />
        <div>Слажем се да HEINEKEN Srbija обрађује моје личне податке за сврху оглашавања.
          Више информација <a href="https://www.heinekensrbija.rs/legal.1121.html" target="_blank">овде.</a></div>
      </div>

      <div className="btn" onClick={handleSubmit(onSubmit)}>ПОШАЉИ</div>

      {serverResponse !== false && <Popup case={serverResponse} prizeCode={prizeCode} />}
    </div>
  )
}

export default EnterCode